<template>
  <div style="padding: 0px 40px">
    <el-row style="margin-bottom: 10px">
      <el-col :span="12">
        <el-input type="text"
                  size="small"
                  v-model="keyword"
                  @input="isTyping = true"
                  :placeholder="$t('keyword')"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </el-col>
      <el-col :span="12" style="text-align: right">
        <el-button size="mini"
                   type="primary"
                   @click="onAddAgentButtonClick()">{{ $t('addAgent') }}
        </el-button>
      </el-col>
    </el-row>
    <el-row v-loading="isTyping">
      <el-col :span="24">
        <div class="contract-table">
          <ul class="contract-table-head">
            <li style="width: 20%; vertical-align: middle;">{{ $t('name') }}</li>
            <li style="width: 10%; vertical-align: middle;">{{ $t('type') }}</li>
            <li style="width: 35%; vertical-align: middle;">{{ $t('market') }}</li>
            <li style="width: 20%; vertical-align: middle;">{{ $t('contactPerson') }}</li>
            <li style="width: 15%; vertical-align: middle;"></li>
          </ul>
        </div>
        <div v-for="(agent, index) of filterAgent()" :key="`agent-${index}`">
          <div class="contract-table">
            <ul>
              <li style="width: 20%">{{ agent.originalData.name }}</li>
              <li style="width: 10%">{{ getAgentTypeName(agent.originalData.agentTypeId) }}</li>
              <li style="width: 35%;">{{ getMarketName(agent.id) }}</li>
              <li style="width: 20%;">{{ getContactPerson(agent.contactPerson) }}</li>
              <li style="width: 15%; text-align: center;">
                <el-button
                  size="mini"
                  type="success"
                  @click="onEditButtonClick(agent)">
                  {{ $t('edit') }}
                </el-button>
                <el-button
                  size="mini"
                  type="danger"
                  @click="onRemoveButtonClick(agent)">
                  {{ $t('remove') }}
                </el-button>
              </li>
            </ul>
            <div class="contract-data-version" v-if="agent.hasMultipleVersion">
              <div class="contract-data-updated">
                <div style="padding: 20px 0 0 20px">
                  <strong>*{{ $t('updatedAgentMessage') }}</strong>
                </div>
                <el-radio-group style="padding-left: 40px" v-model="agentVersionList[agent.id].version" fill="#ff0000"
                                @change="onSelectedAgentChange()">
                  <div class="contract-data-version-radio">
                    <el-radio :label="DATA_VERSION.SELECTED">{{ $t('selectedVersion') }}
                      ({{ bindUpdatedAt(agent.originalData.updatedAt) }})
                    </el-radio>
                  </div>
                  <div class="contract-data-version-radio">
                    <el-radio :label="DATA_VERSION.LATEST">{{ $t('latestVersion') }}
                      ({{ bindLatestUpdatedAt(agent.id) }})
                    </el-radio>
                  </div>
                </el-radio-group>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <popup-agent-list-component
      :special-offer-detail="specialOfferDetail"
      :visible="isShowPopupAgentList"
      :agent-list="agentList"
      :agent-type-list="agentTypeList"
      :market-list="marketList"
      @onSaveSelectAgent="onPopupSelectAgentSave"
      @onClose="onPopupAgentClose">
    </popup-agent-list-component>
    <popup-manage-contact-person-component
      :agent="editAgent"
      :visible="isShowPopupManageContactPerson"
      @onSave="onPopupManageContactPersonSave"
      @onClose="onPopupManageContactPersonClose">
    </popup-manage-contact-person-component>
  </div>
</template>
<script>
import i18nMessages from '@/translations/SpecialOffer/components/TabSpecialOfferAgentComponent.i18n'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import PopupAgentListComponent from './AgentComponents/PopupAgentListComponent'
import PopupManageContactPersonComponent from './AgentComponents/PopupManageContactPersonComponent'
import { debounce, get } from 'lodash'
import { filterDataByKeyword } from '@/services/general-service'
import { dateFormat } from '@/helpers/datetime'
import {
  isUpdatedData,
  isDeletedData,
  DATA_VERSION
} from '@/services/version-service'

export default {
  name: 'TabAgentComponent',
  mixins: [AlertViewMixin],
  i18n: { messages: i18nMessages },
  model: {
    prop: 'specialOfferDetail',
    event: 'onSelectedAgentListChange'
  },
  components: {
    PopupAgentListComponent,
    PopupManageContactPersonComponent
  },
  props: {
    specialOfferDetail: {
      type: Object,
      default: () => {
        return {}
      }
    },
    agentList: {
      type: Array,
      default: () => {
        return []
      }
    },
    marketList: {
      type: Array,
      default: () => {
        return []
      }
    },
    agentTypeList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  watch: {
    keyword: debounce(function () {
      this.isTyping = false
    }, 500)
  },
  data () {
    return {
      isUpdatedData,
      isDeletedData,
      DATA_VERSION,
      isShowPopupAgentList: false,
      isShowPopupManageContactPerson: false,
      keyword: '',
      isTyping: false,
      editAgent: {},
      agentListDataSource: [],
      agentDataList: [],
      agentVersionList: [],
      selectedAgentList: []
    }
  },
  created: function () {
    this.selectedAgentList = this._prepareSelectedAgentList()
    this.agentDataList = this._prepareAgentDataList()

    this.onSelectedAgentChange()
  },
  methods: {
    filterAgent: function () {
      const agentList = this.selectedAgentList
      const searchKeys = ['name']
      const filteredAgentList = filterDataByKeyword(agentList, this.keyword, searchKeys)
      const filteredAgentTypeList = filterDataByKeyword(this.agentTypeList, this.keyword, searchKeys)
      const filteredMarketList = filterDataByKeyword(this.marketList, this.keyword, searchKeys)

      const agentTypeIdList = filteredAgentTypeList.map(item => item.id)
      const agentIdListInMarket = filteredMarketList.map(item => item.agentIdList)
      const explodeAgentIdListInMarket = []
      agentIdListInMarket.forEach((item) => {
        explodeAgentIdListInMarket.push(...item)
      })

      const agentListByType = agentList.filter((item) => {
        if (agentTypeIdList.includes(item.agentTypeId)) {
          return true
        }

        return false
      })

      const agentListByMarket = agentList.filter((item) => {
        if (explodeAgentIdListInMarket.includes(item.id)) {
          return true
        }

        return false
      })

      const filteredAgentByContactPersonList = agentList.filter((item) => {
        const firstName = get(item, 'contactPerson.firstName', '')
        const lastName = get(item, 'contactPerson.lastName', '')
        const contactPersonName = `${firstName} ${lastName}`
        if (contactPersonName.toLowerCase().includes(this.keyword.toLowerCase())) {
          return true
        }

        return false
      })

      const filteredResult = [...new Set([...filteredAgentList, ...agentListByType, ...agentListByMarket, ...filteredAgentByContactPersonList])]
      const sortedResult = filteredResult.sort((a, b) => {
        return (a.name.toLowerCase() < b.name.toLowerCase()) ? -1 : 1
      })
      return sortedResult
    },
    getAgentTypeName: function (agentTypeId) {
      if (!agentTypeId) {
        return '-'
      }

      const agentType = this.agentTypeList.find(item => item.id === agentTypeId)
      const agentTypeName = get(agentType, 'name', '-')
      return agentTypeName
    },
    getMarketName: function (agentId) {
      const marketList = this.marketList.filter(market => market.agentIdList.includes(agentId))

      if (marketList.length === 0) {
        return '-'
      }

      const marketNameList = marketList.map(market => market.name)
      return marketNameList.join(', ')
    },
    getContactPerson: function (contactPerson) {
      if (!contactPerson) {
        return '-'
      }

      const title = get(contactPerson, 'title', '')
      const firstName = get(contactPerson, 'firstName', '')
      const lastName = get(contactPerson, 'lastName', '')
      const contactPersonName = `${title}${firstName} ${lastName}`

      return (contactPersonName.trim() === '') ? '-' : contactPersonName
    },
    onEditButtonClick: function (row) {
      this.editAgent = row
      this.isShowPopupManageContactPerson = true
    },
    onRemoveButtonClick: async function (agent) {
      const confirmMessage = this.$t('confirmRemoveAgentMessage', {
        agentName: agent.name
      })
      const confirmButtonText = this.$t('confirmButtonText')
      const cancelButtonText = this.$t('cancelButtonText')
      const isConfirmRemove = await this.alertConfirmDelete(confirmMessage, confirmButtonText, cancelButtonText)

      if (!isConfirmRemove) {
        return false
      }

      const agentList = this._prepareSelectedAgentList()
      const newArray = agentList.filter(item => Number(item.id) !== Number(agent.id))

      this.selectedAgentList = [...newArray]
      const newAgentList = {
        agentList: [...newArray]
      }
      const specialOfferDetail = Object.assign({}, this.specialOfferDetail, newAgentList)
      this.$emit('onSelectedAgentListChange', specialOfferDetail)
    },
    onPopupSelectAgentSave: function (selectedAgentList) {
      this.selectedAgentList = selectedAgentList.map((selectedAgent) => {
        const currentSelectedAgentData = this.selectedAgentList.find(agent => agent.id === selectedAgent.id)
        const hasMultipleVersion = get(currentSelectedAgentData, 'hasMultipleVersion', false)
        const originalData = get(currentSelectedAgentData, 'originalData', selectedAgent)
        const newSelectedAgentData = {
          hasMultipleVersion: hasMultipleVersion,
          originalData: originalData
        }

        const newSelectedAgent = Object.assign({}, selectedAgent, newSelectedAgentData)

        return newSelectedAgent
      })

      selectedAgentList.forEach((selectedAgent, index) => {
        const defaultVersionData = {
          id: selectedAgent.id,
          index: index,
          version: DATA_VERSION.SELECTED
        }
        const agentVersion = get(this.agentVersionList, `[${selectedAgent.id}]`, defaultVersionData)
        this.agentVersionList[selectedAgent.id] = agentVersion
      })

      const newAgentList = {
        agentList: [...selectedAgentList]
      }
      const specialOfferDetail = Object.assign({}, this.specialOfferDetail, newAgentList)
      this.$emit('onSelectedAgentListChange', specialOfferDetail)
    },
    onSelectedAgentChange () {
      const result = _getResultByVersionList(this.agentVersionList, this.agentDataList, this.agentList)
      const newAgentList = result.map((agent) => {
        const agentData = this.selectedAgentList.find(agentDataSource => agentDataSource.id === agent.id)
        const contactPerson = get(agentData, 'contactPerson', {})
        const newAgentData = {
          contactPerson: contactPerson
        }

        const newAgent = Object.assign({}, agentData, agent, newAgentData)

        return newAgent
      })

      this.selectedAgentList = [...newAgentList]
      const agentList = {
        agentList: newAgentList
      }

      const specialOfferDetail = Object.assign({}, this.specialOfferDetail, agentList)
      this.$emit('onSelectedAgentListChange', specialOfferDetail)
    },
    onAddAgentButtonClick: function () {
      this.isShowPopupAgentList = true
    },
    onPopupAgentClose: function () {
      this.isShowPopupAgentList = false
    },
    onPopupManageContactPersonClose: function () {
      this.isShowPopupManageContactPerson = false
    },
    onPopupManageContactPersonSave: function (contactPerson) {
      this.isShowPopupManageContactPerson = false

      const agentId = get(contactPerson, 'agentId', '')
      const newContactPerson = {
        contactPerson: contactPerson
      }

      const newSelectedAgentList = this.selectedAgentList.map((selectedAgent) => {
        if (selectedAgent.id === agentId) {
          const newSelectedAgent = Object.assign({}, selectedAgent, newContactPerson)
          return newSelectedAgent
        }

        return selectedAgent
      })

      this.selectedAgentList = [...newSelectedAgentList]

      const newAgentList = {
        agentList: [...newSelectedAgentList]
      }
      const specialOfferDetail = Object.assign({}, this.specialOfferDetail, newAgentList)
      this.$emit('onSelectedAgentListChange', specialOfferDetail)
    },
    bindLatestUpdatedAt: function (agentId) {
      const agent = this.agentList.find(item => item.id === agentId)

      if (agent !== undefined) {
        const date = new Date(agent.updatedAt)
        return dateFormat.long(date)
      }
    },
    bindUpdatedAt: function (updatedDate) {
      const date = new Date(updatedDate)
      return dateFormat.long(date)
    },
    _prepareSelectedAgentList: function () {
      const specialOfferAgentList = get(this.specialOfferDetail, 'agentList', [])
      const selectedAgentList = specialOfferAgentList.map((agentData) => {
        const agentSourceData = this.agentList.find(item => item.id === agentData.id)
        const agentUpdatedAt = get(agentData, 'updatedAt', 0)
        const isUpdate = isUpdatedData(this.agentList, agentData)
        const isDeleted = isDeletedData(this.agentList, agentData.id)
        const originalData = {
          hasMultipleVersion: (isUpdate || isDeleted),
          originalData: agentData
        }
        const updatedAgentData = Object.assign({}, agentData, originalData)

        if (agentSourceData !== undefined && agentUpdatedAt === 0) {
          const specialOfferAgentData = Object.assign({}, updatedAgentData, { originalData: agentSourceData })
          const result = Object.assign({}, specialOfferAgentData, agentSourceData)

          return result
        }

        return updatedAgentData
      })

      selectedAgentList.forEach((tableData, index) => {
        this.agentVersionList[tableData.id] = {
          id: tableData.id,
          index: index,
          version: DATA_VERSION.SELECTED
        }
      })

      return selectedAgentList
    },
    _prepareAgentDataList: function () {
      let agentDataList = this.agentList.map((sourceData) => {
        const agentData = this.selectedAgentList.find(item => item.id === sourceData.id)

        if (agentData !== undefined) {
          return agentData
        }

        return sourceData
      })

      agentDataList.sort((prev, next) => (prev.name > next.name) ? 1 : -1)
      return agentDataList
    }
  }
}

function _getResultByVersionList (dataVersionList, dataList, sourceList) {
  const dataVersionIdList = Object.keys(dataVersionList)

  const result = dataVersionIdList.map((id) => {
    const dataVersion = dataVersionList[id]

    if (dataVersion.version === DATA_VERSION.SELECTED) {
      const newData = dataList.find(data => data.id === dataVersion.id)
      return newData
    }

    const sourceData = sourceList.find(item => item.id === dataVersion.id)
    return sourceData
  })

  return result
}
</script>
